import { render, staticRenderFns } from "./HFooter.vue?vue&type=template&id=3d64f7f7&scoped=true&"
import script from "./HFooter.vue?vue&type=script&lang=js&"
export * from "./HFooter.vue?vue&type=script&lang=js&"
import style0 from "./HFooter.vue?vue&type=style&index=0&id=3d64f7f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64f7f7",
  null
  
)

export default component.exports